import { render, staticRenderFns } from "./SendActionPlanModal.vue?vue&type=template&id=12608791&"
import script from "./SendActionPlanModal.vue?vue&type=script&lang=js&"
export * from "./SendActionPlanModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports